var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5Z",
    fill: "#A3DEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0122 17.1448C13.6808 17.1448 16.6549 14.1708 16.6549 10.5021C16.6549 6.83342 13.6808 3.85938 10.0122 3.85938C6.34349 3.85938 3.36945 6.83342 3.36945 10.5021C3.36945 14.1708 6.34349 17.1448 10.0122 17.1448Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0012 11.3155H10.005C9.55267 11.3155 9.18613 10.9488 9.18613 10.4966V7.5064C9.18613 7.05415 9.55267 6.6875 10.005 6.6875C10.4574 6.6875 10.8239 7.05415 10.8239 7.5064V9.67769H12.0012C12.4535 9.67769 12.8201 10.0443 12.8201 10.4966C12.8201 10.9488 12.4535 11.3155 12.0012 11.3155Z",
    fill: "#4E5660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f7c1cf2ec95bee7b631e8300d7ad40a8.svg";
export { ForwardRef as ReactComponent };